var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 34,
    viewBox: "0 0 29 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_125)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_79_125",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 34
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 0.5H0.5V33.5H28.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_79_125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 3.5H18.73C18.1 1.76 16.45 0.5 14.5 0.5C12.55 0.5 10.9 1.76 10.27 3.5H4C2.35 3.5 1 4.85 1 6.5V30.5C1 32.15 2.35 33.5 4 33.5H25C26.65 33.5 28 32.15 28 30.5V6.5C28 4.85 26.65 3.5 25 3.5ZM14.5 3.5C15.325 3.5 16 4.175 16 5C16 5.825 15.325 6.5 14.5 6.5C13.675 6.5 13 5.825 13 5C13 4.175 13.675 3.5 14.5 3.5ZM25 30.5H4V6.5H7V11H22V6.5H25V30.5Z",
    fill: "#EBB42C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 33,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/content.da02a735e5e296194bc2bfdbbb6dcb6e.svg";
export { ForwardRef as ReactComponent };